import React, { useState } from "react";
import { useSecurityQuestionSubmit } from "../../hooks/useSecurityQuestionSubmit";
import { useAuthSupportTicket } from "../../hooks/useAuthSupportTicket";
import { useSelector } from "react-redux";
import { PAGES } from "../../constants/localization";
import { SUPPORT_CATEGORY } from "../../constants/enums";
import { RootState } from "../../types/redux";

// ui components 
import AuthLayout from "../../components/Layouts/AuthLayout";
import SecurityQuestionCard from "../../components/Login/SecurityQuestionCard";
import FaceCheckSupportModal from "../../components/Common/Modals/FaceCheckSupportModal";

const SecurityQuestion = () => {
  const authResult = useSelector((state: RootState) => state.auth.authResult);
  const [showDoNotRememberModal, setShowDoNotRememberModal] = useState(false);

  const { onSubmit, errors } = useSecurityQuestionSubmit();
  const ticket = useAuthSupportTicket({
    category: SUPPORT_CATEGORY.Facecheck, // security questions send as FaceCheck per requirement
    ticketTitle: PAGES.AUTH.SUPPORT.SECURITY_QUESTION_TICKET_TITLE,
  });

  const closeModal = () => {
    setShowDoNotRememberModal(false);
    ticket.reset();
  };

  return (
    <AuthLayout>
      <SecurityQuestionCard
        question={authResult.question}
        dataType={authResult.dataType}
        errors={errors}
        onSubmit={onSubmit as never}
        onDoNotRememberClick={() => setShowDoNotRememberModal(true)}
      />
      <FaceCheckSupportModal
        open={showDoNotRememberModal}
        title={PAGES.AUTH.SECURITY_QUESTION.DO_NOT_REMEMBER_MODAL_TITLE}
        content={PAGES.AUTH.SECURITY_QUESTION.DO_NOT_REMEMBER_MODAL_CONTENT}
        loading={ticket.submitting}
        onClose={closeModal}
        onSubmitClick={ticket.submitTicket}
        onCancelClick={closeModal}
        errors={ticket.errors}
      />
    </AuthLayout>
  );
};

export default SecurityQuestion;